import { Author } from "./Author";
import { getEstimatedReadTime } from "../utils/getEstimatedReadTime";

export class Post {
  objectID: number;
  uuid: string;
  title: string;
  featuredImage: any;
  category: string;
  excerpt: any;
  tags: string[];
  createdAt: string;
  createdAtTimestamp: number;
  publishedAt: string;
  publishedAtTimestamp: number;
  firstPublishedAt: number;
  firstPublishedAtTimestamp: number;
  author?: Author;
  specialist?: Author;
  slug: string;
  fullSlug: string;
  estimatedReadTime: string;

  constructor(raw: any) {
    this.objectID = raw.id;
    this.uuid = raw.uuid;
    this.title = raw.content.title;
    this.featuredImage = raw.content.featuredImage;
    this.category = raw.content.category;
    this.excerpt = raw.content.excerpt;
    this.tags = raw.tag_list;
    this.createdAt = raw.created_at;
    this.createdAtTimestamp = Date.parse(raw.created_at);
    this.publishedAt = raw.published_at;
    this.publishedAtTimestamp = Date.parse(raw.published_at);
    this.firstPublishedAt = raw.first_published_at;
    this.firstPublishedAtTimestamp = Date.parse(raw.first_published_at);
    if (raw.content.author) {
      this.author = new Author(raw.content.author);
    }
    if (raw.content.specialist) {
      this.specialist = new Author(raw.content.specialist);
    }
    this.slug = raw.slug;
    this.fullSlug = raw.full_slug;
    this.estimatedReadTime = getEstimatedReadTime(raw.content.body);
  }
}
